import type { NamePath } from "rc-field-form/lib/interface";

/**
 * @name getFormFieldNames 将Form.Item的name统一转转为数组
 */
export function getFormFieldNames(name: NamePath) {
  if ([null, undefined, NaN, ""].includes(name as string)) return [];
  return Array.isArray(name) ? name : [name];
}

/**
 * @name getPathsValue 根据路径获取对应的值
 */
export function getPathsValue<T = any>(
  paths: Array<number | string>,
  obj: object | any[] = {},
  defaultValue?: T,
): T | undefined {
  return (
    paths?.reduce((acc, key) => (acc != null ? acc?.[key] : undefined), obj) ??
    defaultValue
  );
}

/**
 * @name onFormItemDiff 检测Form Item是否有必要 Update render children node
 * @see https://ant.design/components/form-cn#shouldupdate
 */
export function onFormItemDiff<T extends object | any[] = object | any[]>(
  prevValues: T,
  nextValues: T,
  paths: NamePath,
) {
  const PATHS = Array.isArray(paths) ? paths : [paths];
  return getPathsValue(PATHS, prevValues) !== getPathsValue(PATHS, nextValues);
}

/**
 * @name filterUpperFirst 首字母大小
 * @description lodash 有 upperFirst 方法，为了后续迁移，不依赖了
 */
export function filterUpperFirst(str: string) {
  return (
    str
      ?.split(" ")
      .map((a) => a.toLowerCase().replace(/^./, (c) => c.toUpperCase()))
      .join(" ") ?? ""
  );
}

/**
 * @name addressToFormatting 转换address数据格式
 * @param data
 */
export function addressToFormatting(
  data: Record<
    string,
    Record<"OneUnit" | "TwoUnit" | "ThreeUnit" | "FourUnit", number>
  >,
) {
  const county = {};
  const state = Object.keys(data).map((v) => {
    const value = filterUpperFirst(v);
    county[value] = Object.keys(data[v]).map((v) => {
      const value = filterUpperFirst(v);
      return { value, label: value };
    });
    return { value, label: value };
  });
  return { state, county };
}
